module.exports = __webpack_public_path__ + "media/images/costumes/top/dress-brand-4-c918a46e6024dca2dfe8564653ba34df.jpg";